import { BigNumber } from "ethers";
import React from "react";
import {
  FancyBearLevelDetails,
  FancyBearMetadata,
  NftVestingStats,
} from "types";

export type BearContextValue = {
  tokenId?: number;
  furColor?: number;
  level?: number;
  levelDetails?: FancyBearLevelDetails;
  metadata?: FancyBearMetadata;
  vestingStats?: NftVestingStats;
  honeyConsumed?: BigNumber;
  isLoading: boolean;
  fetchMetadata: () => void;
  readVestingStats: () => void;
  readHoneyConsumed: () => void;
};

const BearContext = React.createContext<BearContextValue>({
  isLoading: false,
  fetchMetadata: () => {},
  readVestingStats: () => {},
  readHoneyConsumed: () => {},
});

export default BearContext;
